var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "product-tile widget",
      attrs: { href: _vm.url, id: _vm.id, tabindex: "0", "aria-live": "polite" }
    },
    [
      _c("div", { staticClass: "product-tile__images" }, [
        _c("div", [
          !_vm.loaded
            ? _c(
                "svg",
                {
                  staticClass:
                    "product-tile__img-main product-tile__img-main--placeholder",
                  attrs: { viewBox: "0 0 304 304", width: "100%" }
                },
                [
                  _c("rect", {
                    attrs: { x: "0", y: "0", width: "100%", height: "100%" }
                  })
                ]
              )
            : _vm._e(),
          _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.loaded,
                expression: "loaded"
              }
            ],
            staticClass: "product-tile__img-main",
            attrs: {
              src: _vm.imageCrop(
                _vm.imageSize(_vm.images.default, "304x304"),
                "center"
              ),
              alt: _vm.images.defaultAlt,
              srcset:
                _vm.imageCrop(
                  _vm.imageSize(_vm.images.default, "168x168"),
                  "center"
                ) +
                " 168w, " +
                _vm.imageCrop(
                  _vm.imageSize(_vm.images.default, "304x304"),
                  "center"
                ) +
                " 304w, " +
                _vm.imageCrop(
                  _vm.imageSize(_vm.images.default, "456x456"),
                  "center"
                ) +
                " 1.5x"
            },
            on: {
              load: function() {
                _vm.loaded = true
              }
            }
          }),
          _c("img", {
            staticClass: "product-tile__img-hover",
            attrs: {
              src: _vm.imageCrop(
                _vm.imageSize(_vm.images.hover, "304x304"),
                "center"
              ),
              alt: _vm.images.hoverAlt,
              srcset:
                _vm.imageCrop(
                  _vm.imageSize(_vm.images.hover, "168x168"),
                  "center"
                ) +
                " 168w, " +
                _vm.imageCrop(
                  _vm.imageSize(_vm.images.hover, "304x304"),
                  "center"
                ) +
                " 304w, " +
                _vm.imageCrop(
                  _vm.imageSize(_vm.images.hover, "456x456"),
                  "center"
                ) +
                " 1.5x"
            }
          })
        ])
      ]),
      _c(
        "div",
        {
          staticClass: "product-tile__static-text-content",
          class: _vm.textAlignment
        },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12-sm product-tile__title color-black" },
              [
                _c("span", { staticClass: "product-tile-title" }, [
                  _vm._v(_vm._s(_vm.staticProductTitle))
                ])
              ]
            )
          ]),
          _c("div", { staticClass: "row" }, [
            !_vm.product.hidePrice && !_vm.product.tags.includes("hiddenprice")
              ? _c("div", { staticClass: "product-tile__price-container" }, [
                  _c(
                    "span",
                    {
                      staticClass: "product-tile__price strong-medium",
                      class:
                        ((_obj = {}),
                        (_obj[_vm.$store.state.comparePriceColor] = _vm.onSale),
                        _obj)
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm._f("moneyWithoutDecimals")(_vm.variant.price)
                        )
                      )
                    ]
                  ),
                  _vm.onSale
                    ? _c(
                        "span",
                        {
                          staticClass:
                            "product-tile__compare-price strong-medium"
                        },
                        [
                          _c("s", [
                            _vm._v(
                              _vm._s(
                                _vm._f("moneyWithoutDecimals")(
                                  _vm.variant.compare_at_price
                                )
                              )
                            )
                          ])
                        ]
                      )
                    : _vm._e()
                ])
              : _vm._e()
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }